






































































































































    import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
    import { Comment } from "@api/models/comments/Comment";
    import { UserProfile } from "@api/models/UserProfile";
    import {EventMembership} from "@api/models/EventMemberShip";
    import {Form} from "@api/models/Form";

    import {RepositoryFabric} from "../../../api/repositories/RepositoryFabric";

    import UserIcon from "../../common/UserIcon.vue";
    import Likes from '../../common/Likes.vue';
    import closeBtn from "../../common/CloseBtn.vue";

    import { process as processMessage } from '../../../common/MessageProcessor';
    import { getUrlParams, ParsedLinkInterface } from "../../../common/urlHelper";
    import {serverLink} from "../../../common/serverLink";
    import {toViewport} from "../../../common/scrollerHelper";
    import {ArrayHelpers} from "../../../common/ArrayHelpers";
    import {Modal} from "../../../common/Modal";
    import {EventBus} from "@common/EventBus";
    import { CommentAttachmentType, CommentAttachment } from "../../../api/enums/CommentTypes";
    import CommentTextarea from "./CommentTextarea.vue"
    import { parseJson } from '@common/TypesHelper';
    import {commentSortingValue} from "@share/comments/helpers/CommentSortingValue";
    import {isCommentUnpublished} from "@share/comments/helpers/IsPublishedHelper";
    import debounce from 'lodash.debounce';
    import { getBackend } from '@service/router/getters';
	import { getBaseUrl } from '@api/helpers/url/baseUrl';
    import {FormsRepository} from "@api/repositories/FormsRepository";

    @Component({
        name: "CommentView",
        components: { UserIcon, Likes, closeBtn, CommentTextarea }
    })
    export default class CommentView extends Vue {
        @Prop({required: true}) comment: Comment;
        @Prop({required: true}) commentators: Record<string, UserProfile>;
        @Prop({required: true}) userId: number;
        @Prop({default: 34}) userIconSize: number;
        @Prop() forms: Form[];
        @Prop({required: false, default: []}) speakers: EventMembership[];
        @Prop({required: false}) elementId: string;
        @Prop({required: true}) alreadyEditing: boolean;
        @Prop({ default: false }) isForPin: boolean;

        form: Form | null = null;
        isFormActive = false;
        isWaitingForTheToken = false;
        editedMessage = '';
        likeHandler: ((value: 1 | null) => void);

        get username(): string {
            if (this.profileLoaded) {
                return `${this.commentators[this.userId].firstName} ${this.commentators[this.userId].lastName}`;
            }
            return '';
        }

        get profileLoaded(): boolean {
            return !!this.userId && !!this.commentators[this.userId]
        }

        get currentLocale(): string {
            return this.$store.state.session.language || 'en';
        }

        get numAnswers(): number {
            if (!this.comment.thread) {return 0;}
            return this.comment.thread.comments.length;
        }

        get answers(): Comment[] {
            if (!this.comment.thread) {return [];}
            return this.comment.thread.comments;
        }

        get numPrevCommentsInThread(): number {
            if (this.comment.thread) {
                return this.comment.thread.previousCount;
            }
            return 0;
        }

        get processedText(): string {
            return processMessage(this.comment.text)
        }

        get dateField() {
            return commentSortingValue(this.comment, this.isAdmin, this.$store.state.session.userId);
        }

        get canDeleteOrEdit() {
            const yesterday = new Date;
            yesterday.setDate(yesterday.getDate() - 1);
            return !this.comment.isDeleted && (this.isAdmin || this.userId === this.$store.state.session.userId
                && yesterday < this.comment.createdAt.toJSDate());
        }

        get canPin() {
            return this.isAdmin && !this.comment.isDeleted && !this.comment.threadId;
        }

        get isAdmin() {
            return this.$store.getters['isAdmin'];
        }

        get eventAdminGroups() {
            return this.$store.getters['services/getServiceParam']('eventsManagement', 'administratorGroupIds') || [];
        }

        get isOrganizerComment() {
            return ArrayHelpers.intersect(this.eventAdminGroups, this.commentators[this.userId]?.groupIds || []).length > 0;
        }

        get isSpeakerComment() {
            return this.speakers.findIndex(speaker => speaker.userId === this.userId) != -1;
        }

        get label() {
            if (this.isOrganizerComment) {
                return this.$t('comments.organizer label');
            }
            if (this.isSpeakerComment) {
                return this.$t('comments.speaker label');
            }
            return '';
        }

        get isForm() {
            return this.attachments?.some((item) => item.type === CommentAttachmentType.form);
        }

        get attachments(): CommentAttachment[] | undefined {
            return parseJson(this.comment.attachments);
        }

        get isUnpublished() {
            return isCommentUnpublished(this.comment.isPublished) && this.comment.userId != this.$store.getters['userId'];
        }

        get formLink() {
            if (this.isForm) {
                const formAttachment = this.attachments?.find((item) => item.type === CommentAttachmentType.form);

                if(formAttachment) {
                    const params: any = {
                        formId: formAttachment.id,
                        project: this.$store.state.session.backend,
                        lang: this.$store.state.session.language,
                        baseUrlWithProjectName: true,
                        server: serverLink(getBaseUrl(this.$store.state.session.backend))
                    };

                    const queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
                    return process.env.VUE_APP_FORMS_LINK + '?' + queryString;
                }
            }
            return '';
        }

        get parsedFormLink(): ParsedLinkInterface {
            if (this.isForm) {
                return getUrlParams(this.formLink);
            }
            return {};
        }

        get formsTitle(): string {
            if (this.isForm) {
                return this.form?.title ?? '';
            }
            return '';
        }

        get originForFrame(): string {
            if (this.isForm) {
                return this.parsedFormLink?.origin ?? '';
            }
            return '';
        }

        get cssDeletedIconStyle(): Record<string, any> {
            return {
                width: this.userIconSize + 'px',
                height: this.userIconSize + 'px',
            }
        }

        get isSubmitted() {
            return !!this.form?.submittedAt;
        }

        get isEditing() {
            return this.comment.isOnEdit
        }

        get isModerating() {
            return isCommentUnpublished(this.comment.isPublished) && this.isAdmin;
        }

        get showPublish() {
            return this.isModerating && !this.isEditing && !this.comment.isDeleted;
        }

        async created() {
            this.likeHandler = debounce((value: 1 | null) => this.like(value), 500);

            if (this.isForm && this.parsedFormLink.search.formId) {
                this.form = this.forms.find(item => item.id == this.parsedFormLink.search.formId) || null;
                if (!this.form) {
                    const formsRepository = this.$repositories.get<FormsRepository>(RepositoryFabric.FORM);
                    const forms = await formsRepository.list({
                        where: {
                            id: this.parsedFormLink.search.formId
                        },
                        take: 1
                    });
                    if (forms.length) {
                        this.form = forms[0];
                    }
                }
            }
        }

        mounted() {
            EventBus.$on('comments/open-form', this.onOpenFormRequest);
            EventBus.$on('comment/flash-comment-on-edit', this.highlightTextarea);
            EventBus.$on('session/tokenUpdated', this.onTokenUpdated);
        }

        beforeDestroy() {
            EventBus.$off('comments/open-form', this.onOpenFormRequest);
            EventBus.$off('comment/flash-comment-on-edit', this.highlightTextarea);
        }

        pin(event: MouseEvent, comment: Comment) {
            if(this.canPin) {
                this.$emit('pinComment', comment)
            }
            else {
                event.stopPropagation()
            }
        }

        showUserProfile(item: UserProfile) {
            if (this.$store.getters['userId'] !== item.userId) {
                EventBus.$emit("showChatByUserId", item.userId);
            }
        }

        generateSession() {
            return {
                sessionId: this.$store.state.session.sessionId,
                backendUrl: serverLink(getBaseUrl(this.$store.state.session.backend)),
                refreshToken: this.$store.state.session.refreshToken,
                userId: this.$store.state.session.userId,
                baseUrl: serverLink(),
                projectName: this.$store.state.session.backend,
                language: this.$store.state.session.language,
                colorScheme: {
                    accent: "#337DF6"
                },
                platform: "web"
            }
        }

        get isPinned(): boolean {
            return this.elementId === "pinned";
        }

        onOpenFormRequest(comment: Comment) {
            if (comment.id === this.comment.id && !this.isPinned) {
                this.isFormActive = true;
            }
        }

        activateForm() {
            if (this.isPinned) {
                EventBus.$emit('comments/open-form', this.comment);
            } else {
                this.isFormActive = true;
            }
        }

        postSession() {
            const sessionData = {
                type: 'session',
                session: this.generateSession()
            };
            this.$refs['form-frame']  &&
            (this.$refs['form-frame'] as HTMLIFrameElement).contentWindow?.postMessage(sessionData, '*');
        }

        frameLoaded() {
            if (this.$refs['form-frame']) {
                this.postSession();
                window.addEventListener('message', this.messageFromIframe);
                setTimeout(
                    () => {
                        toViewport(this.$refs['form-frame'] as HTMLElement);
                    }, 350
                )
            }
        }

        messageFromIframe(event: MessageEvent) {
            if (event.data) {
                try {
                    const data = JSON.parse(event.data);
                    if (data.type == 'updateToken') {
                        this.isWaitingForTheToken = true;
                        this.$repositories.client.refreshToken();
                    }
                    else if (data.from && data.from == 'forms' && data?.formId == this.parsedFormLink.search.formId) {
                        if (data.height) {
                            this.$refs['form-frame'] && ((this.$refs['form-frame'] as HTMLElement).style.height = (data.height + 10) + 'px');
                        }
                    }
                }
                catch (e) {
                    //data is not json
                }
            }
        }

        toEdit() {
            if(this.alreadyEditing) {
                EventBus.$emit('comment/flash-comment-on-edit');
                return;
            }

            this.$emit('startEdit', this.comment)

            this.setIsOnEdit(true);
            this.editedMessage = this.comment.text;
            this.focusToTextarea();
        }

        cancelEditing() {
            this.setIsOnEdit(false);
            this.$emit('cancelEdit', this.comment);
        }

        getTextAreaElement(): HTMLTextAreaElement | null {
            return this.$el.querySelector('textarea');
        }

        getTextareaComponent(): CommentTextarea | null {
            return this.$refs.inputArea as CommentTextarea
        }

        highlightTextarea(highlight = false) {
            if(this.isEditing) {
                this.$nextTick(() => {
                    this.getTextareaComponent()?.highLight("red");
                });

                this.removeSelectionFromTextarea();
                this.focusToTextarea();
            }
        }

        removeSelectionFromTextarea() {
            const textareaElement = this.getTextAreaElement();

            if(textareaElement) {
                textareaElement.value +=' ';
                textareaElement.value = textareaElement.value.slice(0, -1);
            }
        }

        focusToTextarea() {
            this.$nextTick(() => {
                this.getTextAreaElement()?.focus();
            })
        }

        setIsOnEdit(value: boolean) {
            Vue.set(this.comment, 'isOnEdit', value);
        }

        async editComment() {
            if(this.isEditing) {
                if(!this.editedMessage) {
                    const deleteConfirmed = await this.deleteComment();
                    if(!deleteConfirmed) {
                        this.getTextAreaElement()?.focus();
                    }
                    else {
                        this.setIsOnEdit(false);
                    }
                    return;
                }
                this.setIsOnEdit(false);
                this.$emit('editComment', this.comment, this.editedMessage);
                this.editedMessage = '';
            }
        }

        editAnswer(comment: Comment, message: string) {
            this.$emit('editComment', comment, message);
        }

        async deleteComment(withConfirmation = true) {
            if (!withConfirmation) {
                this.$emit('deleteComment', { comment: this.comment, isConfirmed: false });
                return;
            }
            const modal = new Modal({
                title: this.$t('comments.delete confirmation').toString(),
                buttons: [
                    {
                        text: this.$t('common.yes').toString(),
                        class: 'is-red',
                        returnValue: true
                    },
                    {
                        text: this.$t('common.cancel').toString(),
                        class: 'is-transparent-grey',
                        returnValue: false
                    },
                ]
            });

            const confirmResult = await modal.showConfirm();

            if (confirmResult === true) {
                this.$emit('deleteComment', { comment: this.comment, isConfirmed: true });
            }

            return confirmResult;
        }

        like(value: 1 | null) {
            this.$emit('like', { commentId: this.comment.id, value })
        }

        async publish() {
            this.$emit('publishComment', this.comment);
        }

        onTokenUpdated() {
            this.isWaitingForTheToken = false;
            this.postSession();
        }

        destroyed() {
            window.removeEventListener('message', this.messageFromIframe);
            EventBus.$off('session/tokenUpdated', this.onTokenUpdated);
        }
    }
